<template>
    <ModalRouteChild small :parent="parent">
        <SectionTitle :title="config.POSTPONE_TITLE"/>
        <SectionPicture>
            <ArtPostpone :color="config.COLOR_PRIMARY"/>
        </SectionPicture>
        <SectionText :text="config.POSTPONE_DESCRIPTION"/>
    </ModalRouteChild>
</template>
<script>
import { SolutionConsumer } from '@skeepers/platform-framework/mixins';
import { ModalRouteChild } from '@skeepers/platform-framework/components/desktop';
import { SectionTitle, SectionPicture, SectionText } from '@skeepers/platform-framework/components/shared';

import { ArtPostpone } from '@/components/svg';

export default {
    name: 'PostponeModal',
    components: {
        ModalRouteChild, ArtPostpone, SectionTitle, SectionPicture, SectionText,
    },
    mixins: [SolutionConsumer],
    props: {
        parent: {
            type: String,
            default: 'deposit',
        },
    },
};
</script>
<style lang="scss" scoped>
@import '~@skeepers/platform-framework/assets/scss/mixins';

main {
    @include modal(20px);

    > section {
        text-align: center;

        &.image {
            > svg {
                width: 250px;
            }
        }
    }
}
</style>
